import React, { useState } from "react";
import { ChevronDown, ChevronUp, HelpCircle } from "lucide-react";

const HomeFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "Is this medical advice?",
      answer: "No. This is an educational storefront focused on peptides studied in med spa, aesthetic, and wellness research. We do not provide medical advice, diagnoses, or treatment recommendations. Always consult a licensed healthcare professional for medical questions."
    },
    {
      question: "Where do I find ingredient details?",
      answer: "Every product page includes the peptide sequence, form, purity tier, and any applicable research notes. We believe in transparent labeling so research professionals and informed consumers can make sound decisions."
    },
    {
      question: "Do you sell prescription drugs?",
      answer: "No. We do not sell prescription medications, controlled substances, or regulated pharmaceuticals. Our products are research chemicals supplied for laboratory use only. We make no claims of equivalence to prescription products."
    },
    {
      question: "Where can I review policies before buying?",
      answer: "Our Privacy Policy, Terms of Service, Refund Policy, Shipping Policy, and Disclaimer are accessible from the footer of every page. We encourage you to review these before making a purchase."
    },
    {
      question: "Are your products FDA approved?",
      answer: "Research peptides are classified as research chemicals for laboratory use. Most are not FDA-approved drugs. These statements have not been evaluated by the FDA. Not intended to diagnose, treat, cure, or prevent any disease."
    },
    {
      question: "What if I'm not satisfied with my purchase?",
      answer: "Please review our Refund Policy for full details on returns and refunds. We aim to provide clear, fair policies for all customers."
    }
  ];

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#fdf2f4] border border-[#e8c5b8] rounded-full mb-4">
            <HelpCircle className="w-4 h-4 text-[#b89a6d]" />
            <span className="text-sm text-[#b89a6d] font-medium">Common Questions</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#3a2a26] mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-[#7a6b62]">
            Get answers to common questions about our products and policies
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={faq.question}
              className="bg-[#fffaf5] border border-[#f0d8d4] rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/80 transition-colors"
              >
                <span className="text-lg font-medium text-[#3a2a26] pr-4">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-[#b89a6d] flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-[#7a6b62] flex-shrink-0" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-[#7a6b62] leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;
